import { render } from "./ViewAccomodation.vue?vue&type=template&id=2ce99721&scoped=true"
import script from "./ViewAccomodation.vue?vue&type=script&lang=js"
export * from "./ViewAccomodation.vue?vue&type=script&lang=js"

import "./ViewAccomodation.vue?vue&type=style&index=0&id=2ce99721&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce99721"]])

export default __exports__